<!-- Scroll -->
<template>
  <div class="order_main">
    <div class="order">
      <div
        style="
          padding: 10px;
          display: flex;
          flex-direction: column;
          height: 100%;
          justify-content: space-between;
        "
      >
        <div class="order-top">
          <div class="order__number">
            <span> Замовлення №{{ order.localId }} </span>
            <hr style="margin-top: 0" />
          </div>

          <template v-if="hasGuestGroups">
            <div
              v-for="(group, guestNum) in groupedGuests"
              :key="guestNum"
              class="guest-block"
            >
              <h3 class="guest-title">Гість {{ guestNum }}</h3>
              <currentOrderOne
                v-for="product in group.products"
                :key="product.uniqueId"
                :product="product"
                :rozdilit="rozdilit"
                :productKey="product.uniqueId"
                :productsForRozdilit="productsForRozdilit"
              />
              <div class="guest-total">
                <strong> Всього з гостя {{ guestNum }}</strong>
                {{ group.total.toFixed(2) }} ₴
              </div>
            </div>
          </template>

          <template v-else>
            <currentOrderOne
              v-for="product in productsLim10"
              :key="product.uniqueId"
              :product="product"
              :rozdilit="rozdilit"
              :productKey="product.uniqueId"
              :productsForRozdilit="productsForRozdilit"
            />
            <div
              class="more"
              v-if="productsOther.length && !isShow"
              @click="isShow = true"
            >
              Більше...
            </div>

            <template v-if="productsOther.length && isShow">
              <currentOrderOne
                v-for="product in productsOther"
                :key="product.uniqueId"
                :product="product"
                :rozdilit="rozdilit"
                :productKey="product.uniqueId"
                :productsForRozdilit="productsForRozdilit"
              />
            </template>
            <div
              class="more"
              v-if="productsOther.length && isShow"
              @click="isShow = false"
            >
              Згорнути...
            </div>
          </template>
        </div>
        <div
          v-if="order.discountSum > 0"
          class="product-g product-pidsumok discount"
        >
          <div class="product-l">
            <p>Знижка</p>
          </div>
          <div class="product-r">-{{ order.discountSum }}₴</div>
        </div>
        <!-- !!!!!!! -->
        <div
          v-if="!rozdilit && isCanRozdilit"
          class="rozdiliti"
          @click="rozdilitiCheck"
        >
          Розділити рахунок
        </div>

        <div v-if="splitError" class="erorRozdilit">
          <svg
            class="icon-check"
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 24 24"
          >
            <circle
              cx="12"
              cy="12"
              r="11"
              stroke="#BDBDBD"
              stroke-width="2"
              fill="none"
            />
            <path
              d="M8 8 L16 16 M16 8 L8 16"
              fill="none"
              stroke="#BDBDBD"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
          {{ splitError }}
        </div>

        <div
          v-if="rozdilit && isCanRozdilit"
          class="rozdiliti canselRozdilit"
          style="color: red"
          @click="cancelChek"
        >
          Скасувати
        </div>

        <!-- !!!!! -->
      </div>

      <div v-if="rozdilit">
        <button
          @click="splitBill"
          class="btn btn-primary order__sale"
          style="background: green"
        >
          <span>Розділити </span>
        </button>
      </div>
      <div v-else>
        <button
          v-if="order.succseseful"
          class="btn btn-primary order__sale"
          style="background: green"
        >
          Сплачено
          {{ order.sum - order.okruglenie ? order.sum - order.okruglenie : "" }}
          грн.
        </button>
        <button
          v-else
          class="btn btn-primary order__sale"
          @click="payInvoice(order.id, order.sum)"
          :disabled="isOverPaymentLimit || order.sum - prepaymentData <= 0"
        >
          <div v-if="!isOverPaymentLimit">
            <span v-if="prepaymentData"
              >Сплатити <span class="line-through">{{ prepaymentData }}</span>
              {{ formatPrice(order.sum - prepaymentData) }} грн.</span
            >
            <span v-else>Сплатити {{ formatPrice(order.sum) }} грн.</span>
          </div>
          <!-- Це ліміт платіжного сервісу на онлайн-операцію, а не обмеження
               суми самого чека — у закладі такий рахунок оплатити можна. -->
          <div v-else>Ліміт онлайн-оплати — {{ paymentLimit }} грн</div>
        </button>
      </div>
    </div>
    <!-- Договір платника. Показуємо завжди, коли є платіжка: гість укладає його
         натисканням «Сплатити», тож посилання не можна ховати за лімітом суми. -->
    <a
      v-if="paymentTermsLink"
      class="pavila linkPortmone"
      :href="paymentTermsLink"
      target="_blank"
      rel="noopener noreferrer"
    >
      Продовжуючи, ви приймаєте правила сервісу</a
    >
  </div>
</template>

<script>
//Оголошуємо глобально websocket
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import { store } from "@/store.js";
import { createUrlForReview } from "@/utils/urlReviews";
import {
  getPaymentTermsLink,
  ONLINE_PAYMENT_LIMIT,
  ONLINE_PAYMENT_LIMIT_LABEL,
} from "@/utils/paymentTerms";
import { sendSocketTypayGuest } from "../tpayConnect";
import currentOrderOne from "./currentOrderOne.vue";

Vue.use(VueAxios, axios);

export default {
  props: [
    "order",
    "paymentType",
    "uuidGets",
    "prepaymentData",
    "isActiveReviews",
    "onRefresh",
  ],
  data() {
    return {
      splitError: "", // Текст помилки при розділенні
      isShow: false, // Чи показувати додаткові продукти
      rozdilit: false, // Чи увімкнено режим розділення
      productsForRozdilit: {}, // Об'єкт з товарами для розділення
    };
  },
  watch: {
    // При зміні кількості товарів — оновлюємо структуру для розділення
    "order.products.length": function () {
      this.syncProductsRozdilit();
    },
  },
  created() {
    this.syncProductsRozdilit();
  },

  components: {
    currentOrderOne,
  },
  methods: {
    // Синхронізуємо продукти замовлення з productsForRozdilit
    syncProductsRozdilit() {
      this.order.products.forEach((product) => {
        const id = product.uniqueId;
        if (!this.productsForRozdilit[id]) {
          Vue.set(this.productsForRozdilit, id, {
            is: false,
            count: product.count,
            id,
          });
        }
      });
    },
    // Форматує ціну до 2 знаків після коми
    formatPrice(price) {
      return Number(price).toFixed(2);
    },
    // Створює invoice та надсилає його через WebSocket
    payInvoice(orderId) {
      this.$emit("startLoader");
      const messageSend = {
        action: "createInvoice",
        qrToken: `${store.tpayId}`,
        uuidGuest: this.uuidGets,
        payment: {
          paymentSystem: this.paymentType,
          invoice: {
            id: orderId,
          },
        },
      };
      // Додаємо URL для відгуків, якщо активовано
      if (this.isActiveReviews) {
        messageSend.resultUrl = createUrlForReview();
      }
      // Надсилаємо повідомлення через WebSocket
      sendSocketTypayGuest(messageSend);
    },
    // Вмикає/вимикає режим розділення
    rozdilitiCheck() {
      this.splitError = "";
      this.rozdilit = !this.rozdilit;
    },
    // Скасування розділення
    cancelChek() {
      this.splitError = "";
      this.rozdilit = false;
    },
    // Основна логіка розділення чеку

    splitBill() {
      this.splitError = ""; // Очистити повідомлення про помилки
      // Масив, куди збиратимемо обрані для розділення товари
      const data = [];
      const orderProducts = this.order.products;
      // Лічильник повністю розділених товарів
      let fullySplitCount = 0;
      // Загальна кількість обраних товарів
      let totalSelected = 0;
      let errorProducts = [];
      // Перебираємо товари і перевіряємо вибір
      for (let i = 0; i < orderProducts.length; i++) {
        const product = orderProducts[i];
        const id = product.uniqueId;
        const prod = this.productsForRozdilit[id];

        if (prod && prod.is && prod.count > 0) {
          totalSelected++;
          //  Перевіряємо, чи товар вибрано повністю
          const isFullySelected = prod.count >= product.count;
          // Якщо товар вибрано повністю, додаємо до помилкових

          if (isFullySelected) {
            fullySplitCount++;
            errorProducts.push(product.nomenclatureName);
          }
          // Додаємо обраний товар до списку
          data.push({
            nomenclatureId: product.nomenclatureId,
            nomenclatureName: product.nomenclatureName,
            finalAmount: product.finalAmount,
            nomenclatureUnit: product.nomenclatureUnit,
            uniqueId: product.uniqueId,
            price: product.price,
            count: prod.count, //Кількість, яку користувач вибрав для розділення
          });
        }
      }

      if (!data.length) {
        this.splitError = "Не обрано жодного товару для розділення";
        setTimeout(() => {
          this.splitError = "";
        }, 10000);
        return;
      }

      if (
        fullySplitCount === totalSelected &&
        totalSelected === this.order.products.length
      ) {
        this.splitError = `Неможливо повністю розділити всі товари`;
        setTimeout(() => {
          this.splitError = "";
        }, 10000);
        return;
      }

      const messageSend = {
        action: "splitBill",
        qrToken: `${store.tpayId}`,
        uuidGuest: this.uuidGets,
        data: {
          id: this.order.id,
          products: data,
        },
      };

      sendSocketTypayGuest(messageSend);
      this.$emit("startLoader");

      setTimeout(() => {
        this.onRefresh();
      }, 800);
    },
  },
  computed: {
    // Первые 10 продуктов
    productsLim10() {
      return this.order.products.slice(0, 11);
    },
    // Оставшиеся продукты
    productsOther() {
      return this.order.products.length > 11
        ? this.order.products.slice(11)
        : [];
    },
    // Договір платника обраної платіжної системи
    paymentTermsLink() {
      return getPaymentTermsLink(this.paymentType);
    },
    paymentLimit() {
      return ONLINE_PAYMENT_LIMIT_LABEL;
    },
    // Блокуємо, тільки якщо сума ПЕРЕВИЩУЄ ліміт: рівно на ліміті платити можна.
    isOverPaymentLimit() {
      return this.order.sum > ONLINE_PAYMENT_LIMIT;
    },
    // Чи можна розділяти рахунок (наприклад, лише 1 товар — не можна)
    isCanRozdilit() {
      const products = this.order.products;
      switch (products.length) {
        case 0:
          return false;
        case 1:
          return products[0].count != 1;
        default:
          return true;
      }
    },
    // Чи є групи гостей у товарах
    hasGuestGroups() {
      return this.order.products?.some(
        (p) => typeof p.guestGroup !== "undefined"
      );
    },
    // Групування товарів по гостях
    groupedGuests() {
      const groups = {};
      // Перебираємо всі товари з замовлення (запасний варіант — якщо order.products === undefined, беремо пустий масив)
      (this.order.products || []).forEach((p) => {
        const guestIndex = (p.guestGroup || 0) + 1;
        // Якщо ще не створено масиву для цього гостя — ініціалізуємо

        if (!groups[guestIndex]) {
          groups[guestIndex] = {
            products: [],
            total: 0,
          };
        }
        // Додаємо товар у відповідну групу
        // Якщо є finalAmount — беремо його, інакше беремо звичайну ціну (price)
        groups[guestIndex].products.push(p);
        groups[guestIndex].total += Number(p.finalAmount || p.price || 0);
      });
      return groups;
    },
  },
};
</script>

<style>
.order_main {
  display: flex;
  flex-direction: column;
  width: 100%;
  /* background: transparent; */
  min-width: 22%;
}

.more {
  cursor: pointer;
  font-weight: bold;
}

.pavila {
  font-size: 7pt;
}

.pavila span {
  font-weight: bold;
}

.price {
  text-align: end;
  font-weight: bold;
}

.current_order_product {
  opacity: 0.5;
}

/* Доплата */
.line-through {
  text-decoration: line-through;
  /* Додає перекреслення */
  opacity: 0.7;
}

.linkPortmone {
  text-align: center;
  font-size: 6pt;
  padding: 10px 0;
  text-decoration: none;
  color: var(--text-innerBody) !important;
  opacity: 0.5;
  margin-bottom: 15px;
}

.product-g {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
}

.product-l {
  display: flex;
}

.product-pidsumok {
  margin: 15px 0;
}

.discount {
  /* font-style: oblique 20deg; */
  font-weight: 500;
  margin: 0;
  font-size: 12px;
}

.rozdiliti {
  width: 100%;
  color: #49b461;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 8px 0;
}

.canselRozdilit {
  margin: 8px 0 10px 0;
}

.erorRozdilit {
  color: #bdbdbd;
  gap: 5px;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
}

.custom-checkbox {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  width: 24px;
  height: 24px;
}

.custom-checkbox input[type="checkbox"] {
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
}

.custom-checkbox .checkmark {
  width: 100%;
  height: 100%;
  background-color: #eee;
  border-radius: 5px;
  transition: 0.2s ease-in-out;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-checkbox input:checked + .checkmark {
  background-color: #49b461;
  border-color: #49b461;
}

.custom-checkbox .checkmark::after {
  content: "";
  display: none;
  width: 6px;
  height: 12px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg) translateY(-1px);
  /* Зсув вгору на 1px */
}

.custom-checkbox input:checked + .checkmark::after {
  display: block;
}

.order_splitBox {
  display: flex;
  gap: 5px;
}

.btn_count {
  border: none;
  background-color: transparent;
  margin: 0;
  padding: 0;
  cursor: pointer;
}

.guest-block {
  background: #fafafa;
  padding: 12px;
  margin-bottom: 15px;
  border-radius: 10px;
}
.guest-total {
  font-weight: bold;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}

.guest-title {
  text-align: center;
  font-size: 14px;
  font-weight: 800;
}
</style>
